module.exports = __webpack_public_path__ + "img/step3.b6ee903.svg";